import React from "react";
import ContentLoader from "react-content-loader";

type ItemProps = {
  width?: string;
};

type SalesXGroupsLoaderProps = {
  loading: boolean;
  count?: number;
  width?: string;
};

const Item = (props: ItemProps) => {
  return (
    <ContentLoader
      style={{ backgroundColor: "#FFFFFF", marginBottom: "16px", borderRadius: "10px" }}
      // viewBox="0 0 0 0"
      height={113}
      width={props.width ? props.width : "100%"}
    >
      <circle cx="75" cy="55" r="39" />
      <rect x="150" y="25" rx="8" ry="8" width="150" height="25" />
      <rect x="150" y="58" rx="8" ry="8" width="50" height="20" />
      <rect x="94%" y="33" rx="8" ry="8" width="30" height="35" className="lifetimeScore" />
      <rect x="97%" y="30" rx="2" ry="2" width="15" height="40" className="lifetimeScore" />
    </ContentLoader>
  );
};

const SalesXGroupsLoader = (props: SalesXGroupsLoaderProps) => {
  const { loading, width, count } = props;
  return loading ? (
    <>
      {Array.from(Array(count).keys()).map((item, index) => (
        <Item key={index} width={width} />
      ))}
    </>
  ) : null;
};

SalesXGroupsLoader.defaultProps = {
  loading: false,
  count: 5,
};

export default SalesXGroupsLoader;
